module.exports = __webpack_public_path__ + "static/media/YF59_2.91476a41.jpg";